/**
 * Shared profile avatar background colors for Vendor / Customer stakeholders.
 * Used by Account Synopsis Teams and Relationships (matrix, map, rings).
 *
 * - Executive sponsor (vendor): primary brand purple
 * - Account team AE / TAM / etc. (vendor): blue
 * - Customer contact: brown / rose
 */

/** Exec sponsor / executive vendor avatar — matches `$primary-color`. */
export const EXEC_SPONSOR_AVATAR_BG = "#974ae4";

/** Account team (AE, TAM, CSM, …) vendor avatar. */
export const ACCOUNT_TEAM_AVATAR_BG = "#2563eb";

/** Customer team / account contact avatar. */
export const CUSTOMER_CONTACT_AVATAR_BG = "#b06c45";

export type ProfileAvatarKind =
  | "exec_sponsor"
  | "account_team"
  | "customer_contact";

export const getExecSponsorAvatarBg = (): string => EXEC_SPONSOR_AVATAR_BG;

export const getAccountTeamAvatarBg = (): string => ACCOUNT_TEAM_AVATAR_BG;

export const getCustomerContactAvatarBg = (): string =>
  CUSTOMER_CONTACT_AVATAR_BG;

/**
 * Vendor avatar: account-team blue vs exec-sponsor primary purple.
 * @param isAccountTeam - true for AE/TAM/account team members
 */
export const getVendorProfileAvatarBg = (isAccountTeam: boolean): string =>
  isAccountTeam ? ACCOUNT_TEAM_AVATAR_BG : EXEC_SPONSOR_AVATAR_BG;

/** Resolve by kind string. */
export const getProfileAvatarBg = (kind: ProfileAvatarKind): string => {
  switch (kind) {
    case "account_team":
      return ACCOUNT_TEAM_AVATAR_BG;
    case "customer_contact":
      return CUSTOMER_CONTACT_AVATAR_BG;
    case "exec_sponsor":
    default:
      return EXEC_SPONSOR_AVATAR_BG;
  }
};
